import React from "react"
import {FieldViewProps} from "../../../../render/view";
import GoalIconUI5 from "../../../../../gd-components/icons/goal/goal-icon-ui5";
import {ItemIconSize} from "../../../../../gd-components/icons/@const";

type Props = FieldViewProps & {
    iconSize?: ItemIconSize
    iconColorize?: boolean
}

export default function FieldGoalIcon_View(props: Props) {


    const classes = Classes("ui5-field-editable", props.className, {
        // "disabled": props.disabled,
    })

    return (
        <>
            <div className={classes} onClick={props.onClick}>
                <GoalIconUI5 size={props.iconSize} goal={props.model} colorize={props.iconColorize}/>
            </div>
            {props.children}
        </>
    )
}
